// Diagnostics self-health.
//
// Answers "is diagnostics itself working?" without ever affecting the app:
// counters are plain in-memory numbers updated by the writers.

export type DiagnosticsHealth = {
  operational: boolean;
  last_success_at: string | null;
  last_failure_at: string | null;
  failed_writes: number;
  successful_writes: number;
  queued_events: number;
  queued_timeline: number;
  oldest_queued_at: string | null;
  dropped_events: number;
  source_maps_available: boolean;
};

const state = {
  last_success_at: null as string | null,
  last_failure_at: null as string | null,
  failed_writes: 0,
  successful_writes: 0,
  queued_events: 0,
  queued_timeline: 0,
  oldest_queued_at: null as string | null,
  dropped_events: 0,
  source_maps_available: false,
};

export function noteQueued(kind: "event" | "timeline", queueLength: number): void {
  if (kind === "event") state.queued_events = queueLength;
  else state.queued_timeline = queueLength;
  if (!state.oldest_queued_at) state.oldest_queued_at = new Date().toISOString();
}

export function noteDropped(count = 1): void {
  state.dropped_events += count;
}

export function noteFlush(ok: boolean, remaining: number): void {
  const now = new Date().toISOString();
  if (ok) {
    state.successful_writes++;
    state.last_success_at = now;
  } else {
    state.failed_writes++;
    state.last_failure_at = now;
  }
  if (remaining === 0) state.oldest_queued_at = null;
}

export function noteSourceMaps(available: boolean): void {
  state.source_maps_available = available;
}

export function getDiagnosticsHealth(): DiagnosticsHealth {
  return {
    operational: state.failed_writes === 0 || state.successful_writes > 0,
    ...state,
  };
}

export function resetDiagnosticsHealth(): void {
  state.last_success_at = null;
  state.last_failure_at = null;
  state.failed_writes = 0;
  state.successful_writes = 0;
  state.queued_events = 0;
  state.queued_timeline = 0;
  state.oldest_queued_at = null;
  state.dropped_events = 0;
}
